module.exports = __webpack_public_path__ + "static/media/ScooterMapRAD.3ac01c96.png";